export default [
  {
    path: '/my-account',
    name: 'My Account',
    component: () => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/MyAccount'),
    redirect: () => {
      return { name: 'Profile' }
    },
    children: [
      {
        path: 'profile',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/Profile'),
        meta: {
          title: 'Profile'
        }
      },
      {
        path: 'work-experience',
        name: 'WorkExperience',
        component: () => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/WorkExperience'),
        meta: {
          title: 'WorkExperience'
        }
      },
      {
        path: 'products-sourced',
        name: 'ProductsSourced',
        component: () => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/ProductsSourced'),
        meta: {
          title: 'ProductsSourced'
        }
      },
      {
        path: 'identity-documents',
        name: 'IdentityDocuments',
        component: () => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/IdentityDocuments'),
        meta: {
          title: 'IdentityDocuments'
        }
      },
      {
        path: 'payment-details',
        name: 'PaymentDetails',
        component: () => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/PaymentDetails'),
        meta: {
          title: 'PaymentDetails'
        }
      },
      {
        path: '/change-password',
        name: 'ChangePassword',
        component: () => import(/* webpackChunkName: "profile" */ '@/modules/profile/views/ChangePassword'),
        meta: {
          title: 'ChangePassword'
        }
      }
    ]
  }
]
